import React from 'react';
import FormItemEditorRenderForAutoLookup from './FormItemEditorRenderForAutoLookup';
import FormItemDateTimeDisplay from '../display/FormItemDateTimeDisplay';
require('../../styles/FormItemRender.css');

export default class FormItemDateTimeRenderForAutoLookup extends FormItemEditorRenderForAutoLookup
{
	constructor(props) {
		super(props);
	}

	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;
		_value = FormItemDateTimeDisplay.getDisplayText(_value);
		return _value;
	}

	render()
	{
		let newValue = this.props.rowData[this.props.dataField];
		let displayValue = this.getDisplay(newValue);	
		return(
			<div className="gongqi_render_select" style={{padding:'3px'}} ref={ node => this.componentLabel = node }>
				{displayValue}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemDateTimeRenderForAutoLookup.js